function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'home_tab',
  cname: '选项卡',
  configName: 'c_home_tab',
  icon: 't-icon-zujian-xuanxiangka',
  type: 0,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'homeTab',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('mobildConfig', ['defaultArray'])), mapGetters(['mobileTheme'])), {}, {
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        background: "linear-gradient(".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")")
      }, {
        margin: this.configObj.topConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + 0 + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    //页面间距
    mbConfig: function mbConfig() {
      return {
        marginTop: this.configObj.mbConfig.val ? this.configObj.mbConfig.val + 'px' : 0
      };
    },
    //选项卡背景颜色
    tabBgColor: function tabBgColor() {
      return {
        background: "linear-gradient(".concat(this.configObj.tabBgColor.color[0].item, ", ").concat(this.configObj.tabBgColor.color[1].item, ")")
      };
    },
    //商品标题颜色
    titleColor: function titleColor() {
      return {
        color: this.configObj.titleColor.color[0].item
      };
    },
    //标签文字颜色
    fontColor: function fontColor() {
      return this.configObj.fontColor.color[0].item;
    },
    //选中颜色
    checkColor: function checkColor() {
      return {
        background: this.checkThemeStyle ? this.configObj.checkColor.color[0].item : this.themeColor
      };
    },
    //价格颜色
    priceColor: function priceColor() {
      return {
        color: this.priceThemeStyle ? this.configObj.priceColor.color[0].item : this.themeColor
      };
    },
    //已售数量
    soldColor: function soldColor() {
      return {
        color: this.configObj.soldColor.color[0].item
      };
    },
    //内容圆角
    contentStyle: function contentStyle() {
      return {
        'border-radius': this.configObj.contentStyle.val ? this.configObj.contentStyle.val + 'px' : '0'
      };
    },
    //商品名称
    titleShow: function titleShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(0) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    //价格
    priceShow: function priceShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(1) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    //销量
    soldShow: function soldShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(2) !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        this.$nextTick(function () {
          var data = _this.$store.state.mobildConfig.defaultArray[nVal];
          _this.setConfig(data);
        });
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var _this2 = this;
        this.$nextTick(function () {
          var data = _this2.$store.state.mobildConfig.defaultArray[_this2.num];
          _this2.setConfig(data);
        });
      },
      deep: true
    },
    checkThemeStyle: {
      handler: function handler(nVal, oVal) {
        this.configObj.checkColor.isShow = this.configObj.checkThemeStyleConfig.tabVal;
      },
      deep: true
    },
    priceThemeStyle: {
      handler: function handler(nVal, oVal) {
        this.configObj.priceColor.isShow = this.configObj.priceThemeStyleConfig.tabVal;
      },
      deep: true
    }
  },
  data: function data() {
    return {
      curIndex: 0,
      //分类选中
      // 默认初始化数据禁止修改
      defaultConfig: {
        name: 'homeTab',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '选项卡'
        },
        tabItemConfig: {
          tabTitle: '选项卡设置',
          title: '选项卡设置',
          name: 'tabItemConfig',
          tabVal: 0,
          list: [{
            val: '选项卡',
            activeList: null,
            activeTabIndex: 0,
            brandGoodsList: [],
            selectConfigList: [],
            merList: []
          }]
        },
        itemStyle: {
          tabTitle: '展现形式',
          title: '展现样式',
          name: 'itemSstyle',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '单列',
            icon: 'icon-shangpin-danlie'
          }, {
            val: '两列',
            icon: 'icon-shangpin-lianglie'
          }, {
            val: '三列',
            icon: 'icon-shangpin-sanlie'
          }, {
            val: '大图',
            icon: 'icon-shangpin-datu'
          }]
        },
        tabConfig: {
          tabTitle: '商品设置',
          title: '商品列表',
          tabVal: 0,
          isShow: 1,
          list: [{
            name: '指定商品'
          }, {
            name: '指定分类'
          }, {
            name: '指定品牌'
          }, {
            name: '指定商户'
          }]
        },
        //显示内容
        typeConfig: {
          title: '展示信息',
          tabTitle: '显示内容',
          name: 'rowsNum',
          activeValue: [0, 1, 2],
          list: [{
            val: '商品名称'
          }, {
            val: '商品价格'
          }, {
            val: '已售数量'
          }]
        },
        //分类
        selectConfig: {
          title: '商品分类',
          activeValue: [],
          list: [],
          isMultiple: true,
          goodsList: [],
          isShow: 0
        },
        //商户
        activeValueMer: {
          title: '商户名称',
          activeValue: [],
          list: [],
          isMultiple: true,
          goodsList: [],
          isShow: 0
        },
        //品牌
        activeValueBrand: {
          title: '商品品牌',
          activeValue: [],
          list: [],
          isMultiple: true,
          goodsList: [],
          isShow: 0
        },
        goodsSort: {
          title: '商品排序',
          name: 'goodsSort',
          tabVal: 0,
          isShow: 0,
          list: [{
            val: '综合',
            icon: 'icon-zonghe'
          }, {
            val: '销量',
            icon: 'icon-xiaoliang'
          }, {
            val: '价格',
            icon: 'icon-jiage'
          }]
        },
        sortCollation: {
          title: '排序规则',
          name: 'sortCollation',
          tabVal: 0,
          list: [{
            val: '正序',
            icon: 'icon-icon-up'
          }, {
            val: '降序',
            icon: 'icon-icon-down'
          }],
          isShow: 1
        },
        numConfig: {
          val: 6,
          isShow: 1,
          max: 50
        },
        //背景设置
        bgColor: {
          tabTitle: '背景设置',
          title: '背景颜色',
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        tabBgColor: {
          title: '背景颜色',
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        //标签设置
        fontColor: {
          tabTitle: '标签设置',
          title: '文字颜色',
          name: 'fontColor',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        //选中文字色调
        checkThemeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        //价格色调
        priceThemeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        checkColor: {
          isShow: 0,
          title: '选中颜色',
          name: 'checkColor',
          color: [{
            item: '#e93323'
          }],
          default: [{
            item: '#e93323'
          }]
        },
        priceColor: {
          isShow: 0,
          title: '价格颜色',
          name: 'priceColor',
          default: [{
            item: '#e93323'
          }],
          color: [{
            item: '#e93323'
          }]
        },
        soldColor: {
          title: '已售数量颜色',
          name: 'soldColor',
          color: [{
            item: '#666'
          }],
          default: [{
            item: '#666'
          }]
        },
        titleColor: {
          title: '商品标题颜色',
          name: 'titleColor',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        labelColor: {
          tabTitle: '显示内容',
          title: '标签背景颜色',
          name: 'labelColor',
          color: [{
            item: '#e93323'
          }],
          default: [{
            item: '#e93323'
          }]
        },
        // 上间距
        upConfig: {
          title: '上边距',
          tabTitle: '边距设置',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          tabTitle: '边距设置',
          title: '下边距',
          val: 10,
          min: 0,
          max: 100
        },
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 15
        },
        contentConfig: {
          title: '商品间距',
          val: 10,
          min: 0,
          max: 20
        },
        mbConfig: {
          title: '页面间距',
          val: 0,
          min: 0
        },
        topConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        },
        //商品设置
        productList: {},
        goodsList: {
          max: 20,
          list: []
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 7,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'contentStyle',
          val: 7,
          min: 0,
          max: 30
        }
      },
      navlist: [],
      goodslist: [],
      //商品列表
      pageData: {},
      itemStyle: 0,
      bgStyle: 0,
      configObj: null,
      contentConfig: '',
      //内容间距
      checkThemeStyle: 0,
      priceThemeStyle: 0,
      themeColor: ''
    };
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$nextTick(function () {
      if (_this3.num) {
        _this3.pageData = _this3.$store.state.mobildConfig.defaultArray[_this3.num];
        _this3.setConfig(_this3.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      var _this4 = this;
      if (!data) return;
      setTimeout(function () {
        // 让表单重复渲染待编辑数据
        _this4.getConfig(data);
      }, 500);
    },
    getConfig: function getConfig(data) {
      this.configObj = _objectSpread({}, data);
      this.navlist = data.tabItemConfig.list; // 分类
      this.curIndex = data.tabItemConfig.tabVal; //分类选中的值
      this.checkThemeStyle = data.checkThemeStyleConfig.tabVal;
      this.priceThemeStyle = data.priceThemeStyleConfig.tabVal;
      this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1);
      if (data.tabItemConfig.list.length) {
        this.itemStyle = data.tabItemConfig.list[this.curIndex].activeList ? data.tabItemConfig.list[this.curIndex].activeList.styleType : 0;
        switch (data.tabConfig.tabVal) {
          case 0:
            this.goodslist = data.tabItemConfig.list[this.curIndex].activeList ? data.tabItemConfig.list[this.curIndex].activeList.goods : []; //指定商品列表
            break;
          case 1:
            this.goodslist = data.tabItemConfig.list[this.curIndex].activeList ? data.tabItemConfig.list[this.curIndex].selectConfigList : []; //分类商品列表展示
            break;
          case 2:
            this.goodslist = data.tabItemConfig.list[this.curIndex].activeList ? data.tabItemConfig.list[this.curIndex].brandGoodsList : []; //品牌商品列表展示
            break;
          case 3:
            this.goodslist = data.tabItemConfig.list[this.curIndex].activeList ? data.tabItemConfig.list[this.curIndex].merList : []; //商户商品列表展示
            break;
        }
        this.contentConfig = data.contentConfig.val || 0;
      }
    },
    // 列表
    arrayChunk: function arrayChunk(arr) {
      this.leftList = [];
      this.rightList = [];
      for (var i = 0; i < arr.length; i++) {
        if (i % 2 == 0) {
          this.leftList.push(arr[i]);
        } else {
          this.rightList.push(arr[i]);
        }
      }
    }
  }
};